import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/analytics';

import { Singleton } from './modules/@denishussar/html5-game-engine';
import { AnalyticsConstants } from './Game/Constants/AnalyticsConstants';

const SIBUR_DEMO_PATH = 'demo/siburRun/';
const USERS_COLLECTION_PATH = SIBUR_DEMO_PATH + 'users';

export interface UserProps {
    name: string;
    score: number;
    //achievements: number[];
}

export interface UserData {
    id: string,
    data: UserProps
}

@Singleton
export class FirebaseAPI {
    private _db: firebase.firestore.Firestore = null;

    public init(): void {
        firebase.initializeApp({
            apiKey: "AIzaSyCoc5Ym-nvBLE5IvsNUyjs6C5_YjQsTYUc",
            authDomain: "nord-beaver.firebaseapp.com",
            projectId: "nord-beaver",
            storageBucket: "nord-beaver.appspot.com",
            messagingSenderId: "204061968274",
            appId: "1:204061968274:web:ebf2bf7e0454cbeca7e34b"
        });

        this._db = firebase.firestore();
    }

    public async load(id: string): Promise<UserProps> {
        if (id !== '') {
            const doc = await this._db.collection(USERS_COLLECTION_PATH).doc(id);
            const snapshot = await doc.get();

            if (snapshot.exists) {
                const data = snapshot.data() as UserProps;

                console.log('load', id, data);

                return data;
            }
        }

        return null;
    }

    public async save(id: string, props: UserProps): Promise<string> {
        console.log('saveScore', id, props);

        if (id !== '') {
            const doc = await this._db.collection(USERS_COLLECTION_PATH).doc(id);
            const snapshot = await doc.get();
            if (snapshot.exists) {
                doc.update(props);

                return id;
            }
        }
        const doc = await this._db.collection(USERS_COLLECTION_PATH).add(props);

        return doc.id;
    }

    public async getUsers(): Promise<UserData[]> {
        const base: UserData[] = [];
        const snapshot = await this._db.collection(USERS_COLLECTION_PATH).get();

        for (let i = 0; i < snapshot.docs.length; i++) {
            const doc = snapshot.docs[i];
            base.push(
                {
                    id: doc.id,
                    data: {
                        name: doc.data().name,
                        score: doc.data().score,
                        //achievements: doc.data().achievements
                    }
                }
            );
        }

        return base;
    }

    public async analytics(gender: string, eventName: AnalyticsConstants): Promise<void> {
        firebase.analytics().setUserProperties({ gender: gender });
        firebase.analytics().logEvent(eventName, { gender: gender });
    }
}
